import List from "@mui/material/List";
import Item from "@mui/material/ListItem";
import ItemIcon from "@mui/material/ListItemIcon";
import ItemText from "@mui/material/ListItemText";
export default {
    List,
    Item,
    ItemIcon,
    ItemText,
};
//# sourceMappingURL=List.js.map